import React, { useEffect } from 'react';
import events from '../../../../events';
import { locales } from '../../../../translations/locales';
import Loading from '../../../Loading';

const InterventionGroups = (props) => {
    const { theme, locale, data, ModuleRP } = props; // setActivePage,
    useEffect(() => {
        if (data.type !== 'game') {
            ModuleRP.socket.emit(events.CONFIGURE, ModuleRP.gameId);
        }
    }, [data]);
    return (
        data.type === 'game' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">
                        {locales[locale].config.interventionGroups}
                    </h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                            <thead>
                                <tr>
                                    <th>{locales[locale].gamesTable.gameNames}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default InterventionGroups;
